import {
  PRODUCTS_NAMES,
  TYPES_PLANS,
  TYPES_PLANS_DESCRIPTION,
} from "#/constants";
import {
  PageInfoPropsWithPlan,
  PageInfoPropsWithPlanAndCompany,
  PageInfoPropsBase,
  PageInfoPropsWithCheckPlanStatus,
} from "./types";
import { CONTACT_PAGE_DESCRIPTION } from "./utils";

export const PLANS_PAGE_INFO: PageInfoPropsBase = {
  title: "Meu Plano",
};

export const MY_PLAN_PAGE_INFO: PageInfoPropsWithPlan = (typePlan) => ({
  title: `Meu Plano ${PRODUCTS_NAMES[typePlan as TYPES_PLANS]}`,
  description: `Consulte informações de seu plano ${
    TYPES_PLANS_DESCRIPTION[typePlan as TYPES_PLANS]
  }`,
});

export const CONTACT_PAGE_INFO: PageInfoPropsWithPlanAndCompany = (
  typePlan,
  companyLabel
) => ({
  title: `Telefones úteis ${companyLabel} ${PRODUCTS_NAMES[typePlan]}`,
  description: CONTACT_PAGE_DESCRIPTION[typePlan],
});

export const DETAILS_PAGE_INFO: PageInfoPropsWithPlanAndCompany = (
  typePlan,
  companyLabel
) => ({
  title: `Detalhes do plano ${companyLabel} ${PRODUCTS_NAMES[typePlan]}`,
});

export const DEPENDENTS_PAGE_INFO: PageInfoPropsWithCheckPlanStatus = (
  conditionalFlag
) => ({
  title: "Dependentes",
  description: conditionalFlag
    ? "Veja os seus dependentes cadastrados."
    : "Adicione ou exclua dependentes e visualize os dependentes já cadastrados.",
});

export const ADD_DEPENDENT_PAGE_INFO: PageInfoPropsBase = {
  title: "Informe os dados do dependente",
};

export const CONTRACT_PAGE_INFO: PageInfoPropsBase = {
  title: "Dados do contrato",
  description: "Revise os detalhes e visualize os dados.",
};

export const COMPLEMENTARY_DATA_PAGE_INFO: PageInfoPropsBase = {
  title: "Dados complementares",
  description: "Veja seus dados de contato e endereço que estão cadastrados.",
};

export const NEW_DEPENDENTS_PAGE_INFO: PageInfoPropsBase = {
  title: "Confira os dados do dependente",
  description:
    "Certifique-se que os dados estão corretos, você não poderá editar após adicionar.",
};

export const PAYMENT_PAGE_INFO: PageInfoPropsBase = {
  title: "Pagamentos",
  description:
    "Veja a conta que está cadastrada para débito automático do seu plano.",
};
